import { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import Sidebar from '../components/Sidebar';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Bot } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function TelegramConfig() {
  const [config, setConfig] = useState({
    bot_token: '',
    message_template: 'Olá {name}, sua mensalidade de R$ {amount} vence em {date}.'
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchConfig();
  }, []);

  const fetchConfig = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${API}/telegram/config`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (response.data.bot_token) {
        setConfig(response.data);
      }
    } catch (error) {
      console.error('Erro ao carregar configuração');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const token = localStorage.getItem('token');
      await axios.post(`${API}/telegram/config?bot_token=${config.bot_token}&message_template=${encodeURIComponent(config.message_template)}`, {}, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Configuração salva!');
    } catch (error) {
      toast.error('Erro ao salvar configuração');
    }
  };

  return (
    <div className="flex min-h-screen bg-zinc-950" data-testid="telegram-config-page">
      <Sidebar />
      
      <main className="flex-1 md:ml-64 p-4 md:p-6 lg:p-8">
        <div className="mb-8">
          <h1 className="text-3xl sm:text-4xl font-bold text-white mb-2">Telegram Bot</h1>
          <p className="text-slate-400">Configure seu bot do Telegram</p>
        </div>

        {/* Info Card */}
        <div className="bg-sky-600/10 border border-sky-500/30 rounded-xl p-6 mb-8">
          <h3 className="text-lg font-bold text-sky-400 mb-2">Como obter o Bot Token?</h3>
          <ol className="text-sm text-slate-300 space-y-2 list-decimal list-inside">
            <li>Abra o Telegram e busque por <span className="mono text-sky-400">@BotFather</span></li>
            <li>Envie o comando <span className="mono text-sky-400">/newbot</span></li>
            <li>Siga as instruções e copie o token fornecido</li>
            <li>Cole o token no campo abaixo</li>
          </ol>
        </div>

        <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-8 max-w-2xl">
          {loading ? (
            <div className="text-center py-12">
              <p className="text-slate-400">Carregando...</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-6" data-testid="telegram-config-form">
              <div>
                <Label htmlFor="bot_token" className="text-white">Bot Token</Label>
                <Input
                  id="bot_token"
                  placeholder="123456789:ABCdefGHIjklMNOpqrsTUVwxyz"
                  value={config.bot_token}
                  onChange={(e) => setConfig({...config, bot_token: e.target.value})}
                  className="mt-2 mono"
                  data-testid="bot-token-input"
                />
                <p className="text-xs text-slate-400 mt-2">Seu token do @BotFather</p>
              </div>

              <div>
                <Label htmlFor="message_template" className="text-white">Template de Mensagem</Label>
                <textarea
                  id="message_template"
                  value={config.message_template}
                  onChange={(e) => setConfig({...config, message_template: e.target.value})}
                  className="w-full h-32 mt-2 rounded-md border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900"
                  data-testid="message-template-input"
                />
                <p className="text-xs text-slate-400 mt-2">
                  Variáveis disponíveis: <span className="mono">{'{name}'}</span>, <span className="mono">{'{amount}'}</span>, <span className="mono">{'{date}'}</span>
                </p>
              </div>

              <Button type="submit" className="w-full bg-sky-600 hover:bg-sky-700" data-testid="save-config-btn">
                <Bot className="w-4 h-4 mr-2" />
                Salvar Configuração
              </Button>
            </form>
          )}
        </div>
      </main>
    </div>
  );
}
